'use strict';

/* eslint no-undef: "off" */
/**
 * XPark product floor
 */
define('xparkProductFloor',['xparkHomepageApi', 'xparkProductCard', 'addToCartApi', 'busEvent', 'selectSpecModal', 'serialize', 'appStorage'], function (xparkHomepageApi, xparkProductCard, addToCartApi, busEvent, selectSpecModal, serialize, appStorage) {
  return {
    template: '\n      <section class="xp-product-floor" v-if="hasContent">\n        <div class="xp-product-strip-wrap" v-if="horizontalProducts.length">\n          <div class="skeleton-loading" v-if="loading"></div>\n          <div ref="productStrip" class="xp-product-strip" @scroll="updateProductProgress">\n            <xpark-product-card\n              v-for="item in horizontalProducts"\n              :key="\'horizontal-\' + (item.product_id || item.id || item.item_id || item.sku || item.name || item.product_name)"\n              :product="item"\n              card-class="xp-product-card-horizontal"\n              @cart-click="handleCartClick"\n            ></xpark-product-card>\n          </div>\n          <div class="xp-product-strip-progress" aria-hidden="true">\n            <span :style="{ width: productProgress + \'%\' }"></span>\n          </div>\n        </div>\n\n        <div class="xp-product-grid" v-if="verticalProducts.length">\n          <div class="skeleton-loading" v-if="loading"></div>\n          <xpark-product-card\n            v-for="item in verticalProducts"\n            :key="\'vertical-\' + (item.product_id || item.id || item.item_id || item.sku || item.name || item.product_name)"\n            :product="item"\n            @cart-click="handleCartClick"\n          ></xpark-product-card>\n        </div>\n\n        <select-spec-modal\n          v-if="plpProductInfo.product_id"\n          :key="plpProductInfo.product_id"\n          :productInfo="plpProductInfo"\n          :use-global-success-modal="true"\n        ></select-spec-modal>\n      </section>\n    ',
    components: {
      xparkProductCard: xparkProductCard,
      selectSpecModal: selectSpecModal
    },
    data: function data() {
      return {
        horizontalProducts: [],
        productProgress: 0,
        verticalProducts: [],
        plpProductInfo: {},
        loading: false
      };
    },
    created: function created() {
      var data = appStorage.get("productFloor");
      if (data) {
        var json = JSON.parse(data);
        console.log(json);
        if (json && json.horizontalProducts) this.horizontalProducts = json.horizontalProducts;
        if (json && json.verticalProducts) this.verticalProducts = json.verticalProducts;
      }
    },

    computed: {
      hasContent: function hasContent() {
        return Boolean(this.horizontalProducts.length || this.verticalProducts.length);
      }
    },
    mounted: function mounted() {
      this.fetchProductFloor();
    },
    beforeDestroy: function beforeDestroy() {
      window.removeEventListener('resize', this.updateProductProgress);
    },

    methods: {
      fetchProductFloor: function fetchProductFloor() {
        var _this = this;

        this.loading = true;
        xparkHomepageApi.getProductFloor().then(function (data) {
          var floors = data && data.product_floor;

          if (!Array.isArray(floors) || !floors.length) {
            return;
          }

          var horizontalProducts = [];
          var verticalProducts = [];

          floors.forEach(function (floor) {
            var products = Array.isArray(floor.products) ? floor.products : [];

            if (floor.show_type === 'horizontal') {
              horizontalProducts.push.apply(horizontalProducts, products);
              return;
            }

            if (floor.show_type === 'vertical') {
              verticalProducts.push.apply(verticalProducts, products);
            }
          });

          _this.horizontalProducts = _this.normalizeProducts(horizontalProducts);
          _this.verticalProducts = _this.normalizeProducts(verticalProducts);

          _this.$nextTick(function () {
            _this.updateProductProgress();
            window.addEventListener('resize', _this.updateProductProgress, { passive: true });

            var saveData = {
              horizontalProducts: _this.horizontalProducts,
              verticalProducts: _this.verticalProducts
            };
            appStorage.set("productFloor", JSON.stringify(saveData));
          });
        }).catch(function () {}).finally(function () {
          return _this.loading = false;
        });
      },
      handleCartClick: function handleCartClick(product) {
        var data = this.createProductObj(product);

        if (!data.product_id) {
          return;
        }

        window.productDataJSON = {
          data: data
        };

        if (data.product_type === 'configurable') {
          this.plpProductInfo = data;
          this.$nextTick(function () {
            busEvent.$emit('selectSpecShowEvent', 'addToCart');
          });
          return;
        }

        this.addSimpleProductToCart(data);
      },
      createProductObj: function createProductObj(product) {
        var productType = product.product_type || product.type || (Array.isArray(product.configattr) && product.configattr.length ? 'configurable' : 'simple');
        var productId = product.product_id || product.id || product.item_id;
        var simpleStatus = typeof product.status === 'boolean' ? product.status : product.status === 1 || product.status === '1';
        var simpleMaxSaleQty = product.max_sale_qty || product.max_sale_qty === 0 ? product.max_sale_qty : 0;
        var defaultImages = [product.image || product.imgurl || product.product_image].filter(Boolean);
        var base = Object.assign({}, product, {
          product_id: productId,
          product_type: productType,
          status: simpleStatus,
          name: product.name || product.title || product.product_name || '',
          short_description: product.short_description || product.subtitle || '',
          price: product.price || product.final_price || 0,
          price_label: product.price_label || product.final_price_label || '',
          origin_price_label: product.origin_price_label || product.max_price_label || '',
          level_price: product.level_price || {},
          defaultImages: defaultImages,
          images: productType === 'configurable' ? new Map() : defaultImages,
          spec: product.spec || [],
          usps: product.usps || [],
          block: product.block && product.block.block || product.block,
          is_in_wishlist: product.is_in_wishlist || product.in_wishlist ? 1 : 0,
          wishlist_item_id: product.wishlist_item_id || product.item_id || 0,
          attachment: product.attachment || { option: [] },
          xp_product: Number(product.xp_product || 0),
          pickUp: product.pickUp || product.pick_up,
          url_link: product.url_link || product.product_link || product.product_url,
          max_sale_qty: simpleMaxSaleQty
        });

        if (productType === 'configurable') {
          base.configproduct = product.configproduct || {};
          base.configattr = product.configattr || [];
          base.level_price = this.getConfigLevelPrice(product);
        } else {
          base.configproduct = product.configproduct || [];
          base.configattr = product.configattr || [];
        }

        return base;
      },
      getConfigLevelPrice: function getConfigLevelPrice(data) {
        var attrs = data.configattr || [];
        var products = data.configproduct || {};
        var productId = 0;

        if (attrs.length === 1) {
          productId = attrs[0].options[0] && attrs[0].options[0].product_ids[0];
        } else if (attrs.length > 1) {
          var firstIds = new Set(attrs[0].options[0] && attrs[0].options[0].product_ids || []);
          var secondIds = attrs[1].options[0] && attrs[1].options[0].product_ids || [];
          productId = secondIds.filter(function (id) {
            return firstIds.has(id);
          })[0];
        }

        return productId && products['key_' + productId] ? products['key_' + productId].level_price : {};
      },
      addSimpleProductToCart: function addSimpleProductToCart(data) {
        var tmpArr = [];
        tmpArr.id = data.product_id;
        tmpArr.qty = 1;

        addToCartApi({
          data: window.serialize(tmpArr)
        }).then(function () {
          busEvent.$emit('modalSuccess', 'Added to cart successfully');
        });
      },
      normalizeProducts: function normalizeProducts(products) {
        return (products || []).filter(function (item) {
          return Boolean((item.product_image || item.image) && (item.product_name || item.name || item.title));
        });
      },
      formatPrice: function formatPrice(price) {
        return String(price || '').replace(/^₦\s*/, '');
      },
      updateProductProgress: function updateProductProgress() {
        var strip = this.$refs.productStrip;

        if (!strip) {
          this.productProgress = 0;
          return;
        }

        var maxScroll = strip.scrollWidth - strip.clientWidth;

        if (maxScroll <= 0) {
          this.productProgress = 100;
          return;
        }

        var progress = strip.scrollLeft / maxScroll * 100;
        this.productProgress = Math.max(6, Math.min(100, progress));
      }
    }
  };
});
